// src/components/PaperSelector.jsx
import { PAPERS } from "../utils/constants";

const PAPER_STYLES = {
  p1: { background: "linear-gradient(135deg, #ffeef3, #fff5e8)" },
  p2: { background: "linear-gradient(135deg, #e8f4f0, #d4eaf8)" },
  p3: { background: "linear-gradient(135deg, #f5f0e8, #ece4d4)" },
  p4: { background: "linear-gradient(135deg, #f0e8f8, #ffe8f4)" },
  p5: { background: "linear-gradient(135deg, #e8f0f8, #e4f5ec)" },
  p6: { background: "linear-gradient(135deg, #2d2a3e, #3d3560)" },
};

export default function PaperSelector({ selected, onChange }) {
  return (
    <>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 12,
        marginBottom: 16,
      }}>
        {PAPERS.map((p) => (
          <button
            key={p.id}
            onClick={() => onChange(p.id)}
            style={{
              borderRadius: 16,
              border: `2px solid ${selected === p.id ? "#c4845a" : "transparent"}`,
              cursor: "pointer",
              overflow: "hidden",
              aspectRatio: "3/4",
              position: "relative",
              transition: "all .2s",
              boxShadow: selected === p.id ? "0 0 0 3px rgba(196,132,90,.2)" : "none",
              transform: selected === p.id ? "scale(1.02)" : "scale(1)",
            }}
          >
            <div style={{
              ...PAPER_STYLES[p.id],
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              position: "relative",
            }}>
              <span>{p.e}</span>
              <div style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                background: p.id === "p6"
                  ? "rgba(30,25,50,.88)"
                  : "rgba(255,255,255,.88)",
                fontSize: 11,
                color: p.id === "p6" ? "#d0c8f0" : "#5c3d2e",
                textAlign: "center",
                padding: "6px",
                fontFamily: "'Gowun Batang', serif",
              }}>
                {p.n}
              </div>
            </div>
          </button>
        ))}
      </div>
    </>
  );
}
